import PropTypes from 'prop-types';

import styles from './CalendarWeek.scss';

export const CalendarWeek = ({ weekDays }) => (
  <ul className={styles.Calendar__weeks}>
    {weekDays.map((day) => (
      <li key={day}>{day}</li>
    ))}
  </ul>
);

CalendarWeek.propTypes = {
  weekDays: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
};
